'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgUpload(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M6.004 7.798a.577.577 0 00.578-.565V2.236l-.052-.77.25.342.63.684a.504.504 0 00.382.171.491.491 0 00.506-.493.46.46 0 00-.157-.355L6.45.197A.597.597 0 006.004 0a.597.597 0 00-.447.197l-1.69 1.618a.483.483 0 00-.158.355c0 .29.23.493.506.493.138 0 .283-.06.382-.17l.63-.685.25-.342-.045.77v4.997c0 .302.256.565.572.565zM3.025 12H8.97c1.17 0 1.795-.618 1.795-1.782V5.267c0-1.164-.624-1.782-1.795-1.782H7.621V4.74h1.243c.414 0 .644.21.644.65v4.696c0 .447-.23.657-.644.657H3.13c-.42 0-.644-.21-.644-.657V5.392c0-.44.223-.651.644-.651h1.256V3.485h-1.36c-1.171 0-1.796.618-1.796 1.782v4.951c0 1.164.625 1.782 1.795 1.782z", id: "Upload__svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Upload__svg__a" })))));
}

module.exports = SvgUpload;
//# sourceMappingURL=Upload.js.map
